<script setup>
const props = defineProps({
    value: String | Number,
    type: {
        type: String,
        default: 'success'
    },
    contentClasses: {
        type: Array,
        default: () => ['h-3.5', 'tracking-normal'],
    },
})
</script>

<template>
    <div
        :class="[{'bg-green-500' : type === 'success',
            'bg-red-500' : type === 'danger',
            'bg-orange-300 dark:text-dark-blue': type === 'warning',
            'bg-slate-200 dark:bg-slate-800': type === 'info',
            'bg-slate-500 dark:bg-slate-400': type === 'info2xl',
            'bg-blue-600 dark:bg-cyan-500 dark:text-dark-blue': type=== 'primary'}, contentClasses]"
        class="rounded-full py-0.5 px-1 text-center text-xs text-white dark:text-dark-blue font-normal font-condensed min-w-[1.25rem] leading-full cursor-default transition-colors">
        <slot name="content"><span>{{ value }}</span></slot>


    </div>
</template>

<style scoped>

</style>
